exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".with-sidebar-sidebar {\n  min-width: 320px;\n}\n\n@media (min-width: 1024px) {\n  .with-sidebar-sidebar {\n    width: 320px;\n    max-width: 320px;\n  }\n}\n", ""]);

// exports
